// extracted by mini-css-extract-plugin
module.exports = {"responseHeader":"az_fad","leftSide":"az_gad","responseContent":"az_had","responseText":"az_iad","responseDate":"az_jad","rotateChevron":"az_kad"};